export function isFormCorrect(screen_data) {
    let isCorrect = true;
    let re = /^[\w-\.]+@([\w-]+\.)+[\w]{2,4}$/
    let username_re = /^[a-zA-Z0-9-_@.]+$/
    if (screen_data.username.length <= 0) {
        isCorrect = false;
        screen_data.error = 'No se ha introducido usuario';
    } else if (screen_data.email.length <= 0) {
        isCorrect = false;
        screen_data.error = 'No se ha introducido el email';
    } else if (!re.test(screen_data.email)) {
        isCorrect = false;
        screen_data.error = 'Email introducido no es valido';
    } else if (screen_data.email != screen_data.email2) {
        isCorrect = false;
        screen_data.error = 'Los emails introducidos no son iguales';         
    } else if (screen_data.password.length <= 0) {
        isCorrect = false;
        screen_data.error = 'No se ha introducido la contraseña.'
    } else if (screen_data.password.length < 8) {
        isCorrect = false;
        screen_data.error = 'La contraseña debe tener un mínimo de 8 caracteres.' 
    } else if (screen_data.username.includes(' ') || screen_data.password.includes(' ')) {
        isCorrect = false;
        screen_data.error = 'Ni el nombre de usuario, ni la contraseña pueden contener espacios.'
    } else if (!username_re.test(screen_data.username)) {
        isCorrect = false;
        screen_data.error = 'Usuario invalido, no se permiten los caracteres introducidos'; 
    } else if (!screen_data.privacyAccepted){
        isCorrect = false;
        screen_data.error = 'Debe aceptar la política de privacidad' 
    }
    return isCorrect;
}